import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductScope } from '@spartacus/core';
import { CurrentProductService, ProductImagesComponent, MediaComponent, CarouselComponent } from '@spartacus/storefront';
import { KnBrCommonPopUpComponent } from 'src/app/kn-br-customer360/kn-br-common-pop-up/kn-br-common-pop-up.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-product-images',
    templateUrl: './kn-br-product-images.component.html',
    styleUrls: ['./kn-br-product-images.component.scss'],
    imports: [MediaComponent, CarouselComponent, AsyncPipe]
})
export class KnBrProductImagesComponent extends ProductImagesComponent implements OnInit {
  constructor(private service: CurrentProductService, protected modalService: NgbModal) {
    super(service);
  }
  imageList: string[] = [
    'https://images.pexels.com/photos/6474193/pexels-photo-6474193.jpeg?auto=compress&cs=tinysrgb&w=800',
    'https://images.pexels.com/photos/6124239/pexels-photo-6124239.jpeg?auto=compress&cs=tinysrgb&w=800',
  ]
  
  selectedImage: string = this.imageList[0];
  selectedIndex: number = 0;

  selectImage(index: number) {
    this.selectedIndex = index;
    this.selectedImage = this.imageList[index];
  }
  modalRef: any;
  productName;
  ngOnInit(): void {
    this.service.getProduct([ProductScope.DETAILS]).subscribe(res =>
       console.log(res,"this is res"))
  }

  enlargeImg(img) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrCommonPopUpComponent, { centered: true, size: 'xl' });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.image = img;
    modalInstance.header = this.productName;
  };
}
